import ThreeDSecureMethod from './ThreeDSecureMethod';

export default ThreeDSecureMethod;
